import React, { useEffect, useState } from 'react';
import { ArrowLeftOutlined, PrinterOutlined } from '@ant-design/icons';
import { AButton, ATitle } from '../../../../../components';
import { useToast } from '../../../../../hooks/toast';
import api from '../../../../../services/api';
import { IClient } from '../../../../../shared/interfaces';
import { ClientReportListPrint } from '../../../../../shared/reports/Clients/List';
import { Flex } from 'antd';
import { useNavigate } from 'react-router-dom';

const ClientReportListPrintPage: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<IClient[]>([]);
  const { addToast } = useToast();

  useEffect(() => {
    api
      .get('/clients/reports/list')
      .then((response) => {
        setData(response.data.data || response.data);
      })
      .catch(() => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: 'Erro ao carregar relatório',
        });
      });
  }, [addToast]);

  return (
    <>
      <Flex justify="space-between" align="center">
        <ATitle icon={<PrinterOutlined />}>
          Relatório - Lista de Clientes
        </ATitle>
        <AButton
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/clients/reports/list')}
        >
          Voltar
        </AButton>
      </Flex>
      <ClientReportListPrint clients={data} />
    </>
  );
};

export default ClientReportListPrintPage;
